var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('b-row',{staticClass:"ui active dimmer"},[_c('div',{staticClass:"ui loader"},[_c('div',{staticClass:"text-center"},[_c('b-spinner',{staticClass:"mr-2"}),_c('strong',[_vm._v(_vm._s(_vm.loadingText))])],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }